import React from "react"
import styled from "@emotion/styled"
import facepaint from "facepaint"
import YouTube from "./youtube"
import PropTypes from "prop-types"
const breakpoints = [576, 768, 992, 1200]

const mq = facepaint(breakpoints.map(bp => `@media (min-width: ${bp}px)`))

const Container = styled.div`
  text-align: left;
  color: #ffffff;
  margin: 0 auto;
  display: flex;
  width: 100%;
  max-width: 1000px;
  position: relative;
  z-index: 20;
  ${mq({
    padding: ["0 10.0vw 10.0vh", "0 10.0vw", "0 70px 180px", "0 70px 180px"],
    flexDirection: ["column", "row", "row", "row"],
  })}
`
const TextContainer = styled.div`
  padding: 0;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  justify-content: center;
  ${mq({
    width: ["43.5%", "32.0%", "32.0%", "32.0%"],
    paddingLeft: ["0", "30px", "30px", "30px"],
  })}
`

const MovieContainer = styled.div`
  position: relative;
  ${mq({
    marginBottom: ["1.5vh", "0", "0", "0"],
    width: ["100%", "68%", "68%", "68%"],
  })}
`

const Header = styled.h2`
  color: #c7a542;
  font-weight: bold;

  display: flex;
  align-items: center;
  &:after {
    content: "";
    -webkit-box-flex: 1;
    -webkit-flex-grow: 1;
    -ms-flex-positive: 1;
    flex-grow: 1;
    height: 1px;
    background: #c7a542;
    display: block;
    margin-left: 0.4em;
  }
  ${mq({
    fontSize: ["1.6vh", "1.0rem", "1.0rem", "1.0rem"],
  })}
`

const Title = styled.h2`
  line-height: 1.4;
  ${mq({
    marginTop: ["1.2vw", "12px", "12px", "12px"],
    fontSize: ["2.85vw", "1.125rem", "1.125rem", "1.125rem"],
  })}
`

const MovieBlock = ({ className, youtubeId, title, movieImage }) => (
  <Container className={className}>
    <MovieContainer>
      <YouTube youtubeId={youtubeId} movieImage={movieImage}></YouTube>
    </MovieContainer>

    <TextContainer>
      <Header>MOVIE</Header>
      <Title>{title}</Title>
    </TextContainer>
  </Container>
)
MovieBlock.propTypes = {
  className: PropTypes.string,
  youtubeId: PropTypes.string,
  title: PropTypes.object,
  movieImage: PropTypes.string,
}
export default MovieBlock
